<template>
  <div class="gm-admin-tab">
    <server-table
      class="text-center groovemail-spam-bounce-table"
      ref="serverTable"
      :url="spamBounceListingUrl"
      tableRef="blacklistTable"
      :slotData="softBouncesTableSlotData"
      :tableColumns="spamBounceTableColumns"
      :tableOptions="spamBounceTableOptions"
      tableTitle="frontend_groovemail_admin_spam_bounce_emails"
      @loaded="hideLoader()"
      @loading="showLoader()"
    >
    </server-table>
  </div>
</template>

<script>
import axios from 'axios';
import { mapActions } from 'vuex';
import { adminUrls } from '@/utils/urls.js';
import ServerTable from '@groovepages/gd-ui-kit/components/tables/ServerTable.vue';
import monthsMixin from '@/mixin/monthsMixin.js';
import demoModeValuesMixin from '@/mixin/demoModeValuesMixin.js';

let self;

export default {
  middleware: 'auth',
  metaInfo() {
    return { title: this.$t('frontend_groovemail_admin_spam_bounce_emails') };
  },
  mixins: [monthsMixin, demoModeValuesMixin],
  data() {
    return {
      spamBounceListingUrl: adminUrls.blocklistsUrls.spamBounceListing,
      spamBounceTableColumns: ['email', 'created_at', 'actions'],
      spamBounceTableOptions: {
        perPage: 10,
        debounce: 1000,
        alwaysShowPerPageSelect: true,
        perPageValues: [10, 25, 50, 100],
        pagination: { chunk: 5 },
        sortIcon: {
          base: 'fa',
          is: 'fa-sort',
          up: 'fa-sort-asc',
          down: 'fa-sort-desc',
        },
        texts: {
          filterPlaceholder: this.$t('frontend_groovemail_tables_search_query'),
        },
        filterable: ['email'],
        sortable: ['email', 'created_at'],
        headings: {
          email: () =>
            this.$t(
              'frontend_groovemail_components_suppressions_complainers_email_header'
            ),
          created_at: () => this.$t('frontend_groovemail_created_at'),
          actions: () => this.getDataActions(),
        },
        requestFunction(data) {
          const requestParams = { ...data, ascending: 1 - data.ascending };
          const self = this;
          return axios
            .get(self.url, {
              params: requestParams,
            })
            .catch((e) => {
              self.dispatch('error', e);
              self.hideLoader();
            });
        },
        responseAdapter({ data }) {
          if(self.demoMode) {
            const newData = data[0]?.data.map((obj) => ({
              ...obj,
              email: self.basicEmailText,
            }));
            return {
              data: newData,
              count: newData.length,
            };
          }

          return {
            data: data[0].data,
            count: data[0].total,
          };
        },
      },
    };
  },

  components: {
    ServerTable,
  },

  created() {
    self = this;
  },

    watch: {
    // Used to refresh hard bounce data table when demo mode changes
    demoMode() {
      this.$refs.serverTable.$refs.blacklistTable.refresh();
    },
  },

  methods: {
    ...mapActions('loader', ['LOADING']),

    // show loader
    showLoader() {
      this.LOADING(true);
    },

    // hide loader
    hideLoader (){
      this.LOADING(false);
    },

    /**
     * Returns heading for actions column
     * @return {string} - returns actions column heading
     */
    getDataActions() {
      return this.$refs &&
        this.$refs.serverTable &&
        this.$refs.serverTable.$refs.blacklistTable &&
        this.$refs.serverTable.$refs.blacklistTable.count
        ? `${this.$t(
            'frontend_groovemail_admin_blocklists_total_records_label'
          )}: ${this.$refs.serverTable.$refs.blacklistTable.count}`
        : `${this.$t(
            'frontend_groovemail_admin_blocklists_total_records_label'
          )}: 0`;
    },
  },

  computed: {
    // Used to return demoMode value from store.
    demoMode() {
      return this.$store.state.demoMode.isDemoMode;
    },
    
    /**	
     * Returns slot data for spam bounce table.
     * @return {array} details for slot columns for spam bounce table.
    */
    softBouncesTableSlotData() {
      return [
        {
          slotName: 'created_at',
          slotType: 'computed',
          classes: () => {
            return '';
          },
          value: (props) => {
            return props.row.created_at
              ? `${new Date(props.row.created_at).getDate()} ${
                  this.months[new Date(props.row.created_at).getMonth()]
                }, ${new Date(props.row.created_at).getFullYear()}`
              : this.$t('frontend_groovemail_not_available');
          },
        },
      ];
    },
  },
};
</script>


<style lang="scss">
.groovemail-spam-bounce-table #gd-server-table-view {
  .VueTables__table th:last-child {
    text-align: right;
  }

  .VueTables__table th:last-child span {
    display: inline-block;
  }
}
</style>
